const load_columns = [
    {text: 'Unidade de Medida', className: 'text-max-sm'},
    {text: 'Tipo de Medida', className: 'text-max-sm'},
    {text: 'Quantidade', className: 'text-max-sm'},
    {text: 'Remover', className: 'text-max-sm px-1 text-center'}
];

export default load_columns;
